import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import './App.css';
import Yuenchi from './components/Yuenchi.js';
import Oshokujidokoro from './components/Oshokujidokoro.js';
import Mamechishiki from './components/Mamechishiki.js';
import Esoragoto from './components/Esoragoto.js';

function App() {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Add the loading class to body so that your CSS applies correctly
        if (loading) {
            document.body.classList.add('loading');
        }

        // Simulate loading delay
        const timer = setTimeout(() => {
            setLoading(false);
            document.body.classList.remove('loading');
        }, 3000);

        return () => clearTimeout(timer);
    }, [loading]);

    return (
        <Router>
            <div id="wrapper" className={loading ? 'loading' : ''}>
                <div id="frame" className={loading ? '' : 'on'}>
                    <div className="frame-tl"></div>
                    <div className="frame-tr"></div>
                    <div className="frame-r"></div>
                    <div className="frame-b"></div>
                    <div className="frame-l"></div>
                </div>
                <Header />
                <Routes>
                    <Route path="/" element={<HomeContent />} />
                    <Route path="/yuenchi" element={<Yuenchi />} />
                    <Route path="/oshokujidokoro" element={<Oshokujidokoro />} />
                    <Route path="/mamechishiki" element={<Mamechishiki />} />
                    <Route path="/suprematism" element={<Esoragoto />} />
                </Routes>
                <Footer />
            </div>
        </Router>
    );
}

const Header = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const location = useLocation();

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    // Close menu when location changes (when navigating to a new page)
    useEffect(() => {
        setMenuOpen(false);
    }, [location]);

    return (
        <header>
            <div id="header-wp" className="clear">
                <nav className={menuOpen ? 'open' : ''}>
                    <h3 onClick={toggleMenu}>
                        <span>menu</span>
                    </h3>
                    <div className="table">
                        <div className="table-cell">
                            <ul id="menu">
                                <li><Link to="/yuenchi">苹果小姐游园地</Link></li>
                                <li><Link to="/oshokujidokoro">苹果小姐食事处</Link></li>
                                <li><Link to="/mamechishiki">苹果小姐菽知识</Link></li>
                                <li><Link to="/suprematism">苹果小姐绘空事</Link></li>
                            </ul>
                        </div>
                    </div>
                </nav>
            </div>
        </header>
    );
};

const HomeContent = () => (
    <div id="contents" className="clear">
        <div align="center">
            <img src="/logo.png" className="home-logo" alt="Home" />
        </div>

        <div className="home-images">
            <div className="home-image-container">
                <Link to="/yuenchi">
                    <img src="/yuenchi.jpg" alt="游园地" className="home-image" />
                </Link>
            </div>
            <div className="home-image-container">
                <Link to="/oshokujidokoro">
                    <img src="/oshokujidokoro.jpg" alt="食事处" className="home-image" />
                </Link>
            </div>
        </div>

        {/* Open Source Project Section */}
        <div className="opensource-section">
            <h2 className="section-title">Open Source Projects</h2>

            <div className="projects-grid">

                {/* 1. Shounenba */}
                <div className="project-card">
                    <div className="project-info">
                        <h3 className="project-title">Shounenba 正念場</h3>
                        <p className="project-description">
                            Your interview saver, for free. A Python Tkinter-based application that leverages OpenAI's ChatGPT
                            and Deepgram's speech recognition to provide real-time AI assistance during remote interviews.
                        </p>
                        <a
                            href="https://github.com/pythia-copilot/shounenba"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="project-link"
                        >
                            View on GitHub →
                        </a>
                    </div>
                </div>

                {/* 2. Jouri Hakuraku (更新了描述) */}
                <div className="project-card">
                    <div className="project-info">
                        <h3 className="project-title">Jouri Hakuraku 常理剥落</h3>
                        <p className="project-description">
                            A next-generation OSINT platform for structured analysis. It aggregates data from sources like Discord, applies LLM-powered triage filtering via LangGraph, and delivers daily/weekly intelligence briefings through a modern Streamlit dashboard.
                        </p>
                        <a
                            href="https://github.com/Pommelle/Jouri_Hakuraku"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="project-link"
                        >
                            View on GitHub →
                        </a>
                    </div>
                </div>

                {/* 3. Openclaw (更新了链接) */}
                <div className="project-card contribution-card">
                    <div className="project-info">
                        <h3 className="project-title">
                            Openclaw

                        </h3>
                        <p className="project-description">
                            Proud contributor to the Openclaw project. Contributed to core features and improved overall system reliability.
                        </p>
                        <a
                            href="https://github.com/openclaw/openclaw"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="project-link"
                        >
                            View Project →
                        </a>
                    </div>
                </div>

            </div>
        </div>
    </div>
);

const Footer = () => (
    <footer id="footer">
        <p className="cr">&copy; 2025 苹果小姐. All Rights Reserved.</p>
    </footer>
);

export default App;